import { render, staticRenderFns } from "./AddBlockNumbersModal.vue?vue&type=template&id=89d69d86&"
import script from "./AddBlockNumbersModal.vue?vue&type=script&lang=js&"
export * from "./AddBlockNumbersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports